import React, { useState } from "react";
import UserProfile from "./UserProfile";
import Button from "./../common/Button";
import ReplyForm from "./ReplyForm";
import QuotedContent from "./QuotedContent";

const ReplyContainer = ({
    title,
    author,
    date,
    time,
    content,
    isOnline,
    isInactive,
    userPosts,
    registrationDate,
    onAddReply,
    postId,
    replyId,
}) => {
    const [showReplyForm, setShowReplyForm] = useState(false);

    const handleReplyWithQuote = () => {
        setShowReplyForm(true);
    };

    const handleCancelReply = () => {
        setShowReplyForm(false);
    };

    const handleSubmitReply = (replyText) => {
        if (onAddReply) {
            onAddReply(postId, replyId, {
                author: "John Doe", // Current user
                content: replyText,
                quotedAuthor: author,
                quotedContent: content,
            });
        }
        setShowReplyForm(false);
    };

    return (
        <article className="p-6 mt-6 w-full rounded-2xl border border-gray-200 border-solid max-md:px-5 max-md:max-w-full">
            <div className="flex flex-wrap gap-6 items-start w-full max-md:max-w-full">
                <div className="flex flex-col flex-1 shrink basis-6 min-w-60 max-md:max-w-full">
                    <div className="flex flex-wrap gap-2 items-start w-full text-xl font-semibold leading-snug text-blue-500 max-md:max-w-full">
                        <span>Answer:</span>
                        <h2 className="flex-1 shrink basis-0 max-md:max-w-full">{title}</h2>
                    </div>
                    <div className="self-start mt-4">
                        <div className="flex gap-1 items-center">
                            <div className="flex gap-1 items-start self-stretch my-auto text-sm font-medium leading-loose whitespace-nowrap">
                                <span className="text-zinc-600">from</span>
                                <span className="text-blue-500">{author}</span>
                            </div>
                            <div className="flex gap-2 justify-center items-center self-stretch p-1 my-auto w-3.5">
                                <img
                                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/cdb48d7769e2f15c2f2cabd1235c7486aa7027f48a84d2262f767210e06ac449?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0"
                                    alt="Separator dot"
                                    className="object-contain self-stretch my-auto w-1.5 aspect-square"
                                />
                            </div>
                            <time className="self-stretch my-auto text-sm leading-loose text-gray-400">
                                {date}
                            </time>
                            <div className="flex gap-2 justify-center items-center self-stretch p-1 my-auto w-3.5">
                                <img
                                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/cdb48d7769e2f15c2f2cabd1235c7486aa7027f48a84d2262f767210e06ac449?placeholderIfAbsent=true&apiKey=eb226542e6a54a1c8fe305b1d38613f0"
                                    alt="Separator dot"
                                    className="object-contain self-stretch my-auto w-1.5 aspect-square"
                                />
                            </div>
                            <time className="self-stretch my-auto text-sm leading-loose text-gray-400">
                                {time}
                            </time>
                        </div>
                    </div>
                    <p className="mt-4 text-base leading-loose text-gray-700 max-md:max-w-full">
                        {content}
                    </p>
                    {showReplyForm && (
                        <ReplyForm
                            quotedAuthor={author}
                            quotedContent={content}
                            onCancel={handleCancelReply}
                            onSubmit={handleSubmitReply}
                        />
                    )}
                    <QuotedContent author={author} content={content} />

                </div>
                <UserProfile
                    username={author}
                    isOnline={isOnline}
                    isInactive={isInactive}
                    postCount={userPosts}
                    registrationDate={registrationDate}
                />
            </div>
            <div className="flex flex-wrap gap-10 justify-between items-end mt-6 w-full text-sm leading-loose min-h-[42px] max-md:max-w-full">
                <div className="flex flex-wrap gap-4 items-center min-w-60 w-[680px] max-md:max-w-full">
                    <div className="flex gap-2 items-start self-stretch my-auto text-gray-800 whitespace-nowrap">
                        <div className="flex gap-0.5 items-center">
                            <button
                                aria-label="Like"
                                className="flex shrink-0 self-stretch my-auto w-6 h-6"
                            />
                            <span className="self-stretch my-auto text-ellipsis">8th</span>
                        </div>
                        <div className="shrink-0 self-stretch w-0 h-6 bg-gray-200 border border-gray-200 border-solid" />
                        <div className="flex gap-0.5 items-center">
                            <button
                                aria-label="Dislike"
                                className="flex shrink-0 self-stretch my-auto w-6 h-6"
                            />
                            <span className="self-stretch my-auto text-ellipsis">3</span>
                        </div>
                    </div>
                    <Button
                        variant="outline"
                        icon="message-edit"
                        className="flex gap-2 justify-center items-center self-stretch px-4 py-1.5 my-auto font-medium text-rose-700 border border-rose-700 border-solid rounded-full"
                        onClick={handleReplyWithQuote}
                    >
                        Reply with quote
                    </Button>
                </div>
                <div className="flex gap-3 items-center font-medium text-gray-700 whitespace-nowrap">
                    <Button
                        variant="neutral"
                        icon="warning-2"
                        custom="p-4"
                        className="flex gap-2 justify-center items-center self-stretch px-4 py-1.5 my-auto border border-gray-700 border-solid"
                    >
                        Report
                    </Button>
                </div>
            </div>
        </article>
    );
};

export default ReplyContainer;
